import { render } from "./AcceptanceDetailDialog.vue?vue&type=template&id=09173504&scoped=true"
import script from "./AcceptanceDetailDialog.vue?vue&type=script&lang=ts"
export * from "./AcceptanceDetailDialog.vue?vue&type=script&lang=ts"

import "./AcceptanceDetailDialog.vue?vue&type=style&index=0&id=09173504&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-09173504"

export default script